import styled, { css } from 'styled-components';
import { svgToCssUrl } from 'src/utils/svgToCssUrl';
import { SvgHelperWrapper } from 'src/components';
import StageUpBackground from '../assets/stage-up-background.svg';

export const ModalContent = styled.div(
  ({ theme }) => css`
    height: 100%;
    width: 100%;
    background-color: ${theme.co.primary98};
  `,
);

export const Center = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: ${theme.co.secondary20};
    background-position: center;
    background-repeat: no-repeat;
    background-image: ${svgToCssUrl(<SvgHelperWrapper Svg={StageUpBackground} />)};
  `,
);

export const Header = styled.h1(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.accent.xl};
    margin: ${theme.sz.s2};
  `,
);

export const NextStage = styled.h3(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xs};
    margin: 0;
    background-color: ${theme.co.primary60};
    padding: ${theme.sz.s2} ${theme.sz.s3};
    border-radius: ${theme.bo.small};
    display: flex;
    gap: ${theme.sz.s2};

    svg {
      height: ${theme.sz.s6};
      width: ${theme.sz.s6};
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    max-width: ${theme.sz.xs};
    margin-bottom: ${theme.sz.s7};
    padding: 0 ${theme.sz.s6};
    text-align: center;
  `,
);

export const AnimationRoot = styled.div(
  ({ theme }) => css`
    position: relative;
    width: ${theme.sz.xs};
    height: ${theme.sz.xs};
    margin: ${theme.sz.s8} 0;
  `,
);

export const AnimationContainer = styled.div(
  ({ theme }) => css`
    position: absolute;
    width: ${theme.sz.xs};
    height: ${theme.sz.xs};
    top: 0;
  `,
);

export const Language = styled.h1(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.accent.xxl};
    color: ${theme.co.secondary20};
    margin-top: 0;
    margin-bottom: ${theme.sz.s1};
  `,
);
